"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleInitializer = exports.LocaleInitializationError = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const LOCALE_ERROR = 'Locale initialization error';
class LocaleInitializationError extends web_ui_framework_1.InitializerError {
    constructor(message) {
        super(LOCALE_ERROR, message);
    }
}
exports.LocaleInitializationError = LocaleInitializationError;
class LocaleInitializer extends web_ui_framework_1.Initializer {
    constructor(language) {
        super();
        this.launch = async () => {
            try {
                web_ui_framework_1.locale.setLocale(this.language);
                return web_ui_framework_1.locale;
            }
            catch (e) {
                throw new LocaleInitializationError(e);
            }
        };
        this.language = language;
    }
}
exports.LocaleInitializer = LocaleInitializer;
//# sourceMappingURL=locale.initializers.js.map